import { render, staticRenderFns } from "./HistoryCases.vue?vue&type=template&id=b4f5a1d8&scoped=true"
import script from "./HistoryCases.vue?vue&type=script&lang=js"
export * from "./HistoryCases.vue?vue&type=script&lang=js"
import style0 from "./HistoryCases.vue?vue&type=style&index=0&id=b4f5a1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f5a1d8",
  null
  
)

export default component.exports